"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressAttributesSchema = void 0;
const zod_1 = require("zod");
exports.AddressAttributesSchema = zod_1.z.object({
    id: zod_1.z.number(),
    ownerType: zod_1.z.string(),
    ownerId: zod_1.z.number(),
    address: zod_1.z.string().min(1),
    zipcode: zod_1.z.string(),
    lat: zod_1.z.number(),
    lng: zod_1.z.number(),
    utcOffsetMinutes: zod_1.z.number(),
    instructions: zod_1.z.string().nullable().optional(),
    province: zod_1.z.string(),
    regency: zod_1.z.string(),
    district: zod_1.z.string(),
    addressName: zod_1.z.string().nullable().optional(),
    recipientName: zod_1.z.string().nullable().optional(),
    recipientPhone: zod_1.z.string().nullable().optional(),
});
//# sourceMappingURL=address.js.map